import React from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';

interface ProductVideoProps {
  productVideoUrl: string;
  height: string;
  width: string;
  className: string;
  autoPlay: boolean;
}

const ProductVideo: React.FC<ProductVideoProps> = ({
  productVideoUrl,
  height,
  width,
  className = '',
  autoPlay = false,
}) => {
  const onPlayerError = (event) => {
    console.error('YouTube Player Error:', event.data);
  };

  const opts: YouTubeProps['opts'] = {
    height,
    width,
    playerVars: {
      autoplay: autoPlay ? 1 : 0,
    },
  };
  const match = productVideoUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^?&/]+)/);
  const videoId = match ? match[1] : null;

  return (
    <>
      {videoId ? (
        <YouTube videoId={videoId} opts={opts} className={className} onError={onPlayerError} />
      ) : (
        <div>Invalid YouTube URL</div>
      )}
    </>
  );
};

export default ProductVideo;
